import { Stack, Typography } from '@mui/material';
import { TooltipProps } from '@mui/material';
import { ReactElement } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { useTrackUserEvent } from '@/hooks/useTrackUserEvent';
import { COLORS } from '@/styles/tokens/colors';

import { Tooltip } from '../Tooltip/Tooltip';

export interface ProUpsellTooltipProps
  extends Omit<TooltipProps, 'children' | 'title'> {
  children: ReactElement;
  show?: boolean;
  title?: string;
  body?: string;
}

export function ProUpsellTooltip({
  children,
  show = true,
  title = 'Unlock more with Pro',
  body = 'Upgrade now to take your planning to the next level. Gain access to advanced tools and insights that deliver even greater value to you and your clients.',
  ...props
}: ProUpsellTooltipProps) {
  const trackUserEvent = useTrackUserEvent();
  if (!show) return children;

  return (
    <Tooltip
      {...props}
      placement="right-start"
      title={
        <Stack sx={{ width: 280, p: 1 }}>
          <Typography
            variant="title-xs"
            color={COLORS.TEAL[700]}
            sx={{ fontWeight: 600, mb: 1 }}
          >
            {title}
          </Typography>
          <Typography variant="body-xs">{body}</Typography>

          <Button
            variant="primary"
            size="xs"
            onClick={() => {
              trackUserEvent('upsell tooltip clicked');
              window.open(
                'https://www.withluminary.com/luminary-pro-upgrade?utm_source=in-app&utm_medium=module&utm_campaign=go-to-pro&utm_term=v1',
                '_blank'
              );
            }}
            sx={{
              alignSelf: 'flex-end',
              mt: 1,
              bgcolor: COLORS.TEAL[700],
              color: 'white',
              '&:hover': {
                bgcolor: COLORS.TEAL[800],
              },
              border: `1px solid ${COLORS.TEAL[700]}`,
            }}
          >
            Learn more
          </Button>
        </Stack>
      }
    >
      {children}
    </Tooltip>
  );
}
